<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 关于 -->
      <el-row>
        <el-col :span="24" class="scene_top" v-lazy:background-image="aboutImg.picture6">
          <div class="scene_topContent">
            <ul>
              <li>
                <p>企业愿景</p>
                <p>让城市空间更有品质</p>
                <h1>01</h1>
              </li>
              <li>
                <p>价值观</p>
                <p>以客户为中心，以奋斗有成就者为本</p>
                <h1>02</h1>
              </li>
              <li>
                <p>企业理念</p>
                <p>让员工实现物质富足，实现精神丰盈</p>
                <h1>03</h1>
              </li>
              <li>
                <p>企业精神</p>
                <p>实用实干，能上能下，能打硬仗<br />绝对服从，立马执行</p>
                <h1>04</h1>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <!-- 企业资质 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space enterpriseQualification">
            <div class="title">
              <h3>企业资质</h3>
              <i class="lineTitel"></i>
            </div>
            <div class="tips">
              胡润中国最具投资价值湖南<span>20强</span>企业
              <p>国家级高新技术企业、双软企业等众多知名企业达成战略合作</p>
            </div>
            <el-row>
              <el-col :span="24">
                <div class="mapContents">
                  <div>
                    <ul>
                      <li></li>
                      <li>
                        <img v-lazy="aboutImg.picture1" />
                      </li>
                      <li></li>
                    </ul>
                    <ul>
                      <li>
                        <img v-lazy="aboutImg.picture2" />
                      </li>
                      <li></li>
                      <li>
                        <img v-lazy="aboutImg.picture3" />
                      </li>
                    </ul>
                  </div>
                  <div class="companyInfoImg">
                    <img v-lazy="aboutImg.picture4" />
                  </div>

                  <div>
                    <ul>
                      <li>
                        <img v-lazy="aboutImg.picture5" />
                      </li>
                      <li></li>
                    </ul>
                    <ul>
                      <li></li>
                      <li></li>
                    </ul>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 发展历程 -->
      <el-row>
        <el-col :span="24" class="fzlc_contentStyle">
          <div class="title">
            <h3>发展历程</h3>
            <i class="lineTitel"></i>
          </div>
          <div class="content_space fzlc_content" v-lazy:background-image="aboutImg.picture7">
            <el-row>
              <el-col :span="24">
                <div class="developmentHistory">
                  <ul>
                    <li>
                      <span>2017</span>
                      <i></i>
                      <i></i>
                    </li>
                    <li>
                      <span>2016</span>
                      <i></i>
                      <i></i>
                    </li>
                    <li>
                      <span>2015</span>
                      <i></i>
                      <i></i>
                    </li>
                    <li>
                      <span>2014</span>
                      <i></i>
                      <i></i>
                    </li>
                    <li>
                      <span>2012</span>
                      <i></i>
                      <i></i>
                    </li>
                    <li>
                      <span>2008</span>
                      <i></i>
                      <i></i>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <p>B轮融资<br />双软企业荣誉</p>
                    </li>
                    <li>
                      <p>荣获国家高新技术企业荣誉<br />A+轮融资 沃富金信</p>
                    </li>
                    <li>
                      <p>
                        玖创资本、唯猎资本A轮融资<br />移动购房平台发布<br />荣获长沙最佳房地产运营商
                      </p>
                    </li>
                    <li>
                      <p>经纪人移动管理平台发布</p>
                    </li>
                    <li>
                      <p>实效营销机构成立</p>
                    </li>
                    <li>
                      <p>蓝海购一起购房网成立</p>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  min-width: 1600px;
}
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    // background: url(~@/assets/images/BOSAboutBackground.png) no-repeat;
    background-size: 100% 100%;
    height: 630px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      ul {
        width: 1400px;
        display: flex;
        position: relative;
        justify-content: space-between;
        li {
          list-style: none;
          font-size: 18px;
          color: #ffffff;
          font-weight: 400;
          margin-bottom: 32px;
          margin-right: 77px;
          text-align: center;
          span {
            font-weight: bold;
            margin-right: 14px;
          }
          > p:nth-of-type(1) {
            margin-bottom: 24px;
            font-size: 30px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
          }

          h1 {
            font-size: 174px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #fefefe;
            opacity: 0.05;
            position: absolute;
            top: -66px;
          }
        }

        > li:nth-of-type(1) {
          h1 {
            margin-left: -14px;
          }
        }

        > li:nth-of-type(2) {
          h1 {
            margin-left: 45px;
          }
        }

        > li:nth-of-type(3) {
          h1 {
            margin-left: 45px;
          }
        }

        > li:last-of-type {
          margin-right: 0;
          h1 {
            margin-left: 23px;
          }
        }
      }
    }
  }

  //企业资质
  .enterpriseQualification {
    .tips {
      font-size: 16px;
      margin: 0 auto;
      margin-top: 21px;
      margin-bottom: 51px;
      line-height: 32px;
      span {
        font-size: 20px !important;
        font-weight: bold;
        color: #28449f;
        margin:0 10px;
      }
    }

    .mapContents {
      display: flex;
      justify-content: center;
      > div:nth-of-type(1) ul:nth-of-type(1) {
        display: flex;
        margin-bottom: 12px;
        li {
          list-style: none;
          margin-right: 11px;
          width: 226px;
          height: 165px;
        }
        > li:nth-of-type(1) {
          background: #27439f;
        }
        > li:nth-of-type(3) {
          background: #3e67ee;
        }
      }

      > div:nth-of-type(1) ul:nth-of-type(2) {
        display: flex;
        li {
          list-style: none;
          margin-right: 11px;
          width: 226px;
          height: 165px;
        }
        > li:nth-of-type(2) {
          background: #f6f6f6;
        }
      }

      .companyInfoImg {
        width: 271px;
        height: 342px;
        img {
          max-width: 271px;
          max-height: 342px;
        }
      }

      > div:nth-of-type(3) ul:nth-of-type(1) {
        display: flex;
        margin-bottom: 12px;

        li {
          list-style: none;
          height: 165px;
        }

        > li:nth-of-type(1) {
          margin: 0px 19px 0 15px;
        }

        > li:nth-of-type(2) {
          width: 154px;
          background: #f6f6f6;
        }
      }

      > div:nth-of-type(3) ul:nth-of-type(2) {
        display: flex;
        li {
          list-style: none;
          height: 165px;
        }
        > li:nth-of-type(1) {
          width: 154px;
          background: #27439f;
          margin: 0px 19px 0 15px;
        }

        > li:nth-of-type(2) {
          width: 226px;
          background: #3e67ee;
        }
      }
    }
  }

  //关于桅灯
  .content_space {
    background: #fff;
    padding: 0 230px 0px 230px;
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      h3 {
        font-size: 30px;
        font-weight: 400;
        margin: 71px 0 88px 0;
      }
    }

    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      border-top: 1px #f6f6f6 solid;
      padding-top: 30px;
      h3 {
        margin-bottom: 0 !important;
        font-size: 30px;
        font-weight: 400;
        margin: 71px 0 88px 0;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }
    .mapContent {
      padding-bottom: 99px;
      position: relative;
    }

    .developmentHistory {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      /* flex-direction: column; */
      justify-content: center;
      align-items: center;
      ul {
        li {
          font-size: initial;
          list-style: none;
        }
      }

      > ul:nth-of-type(1) {
        border-right: 2px solid #d9d9d9;
        // height: 940px;
        li {
          display: flex;
          align-items: center;
          position: relative;
          margin-bottom: 83px;
          span {
            font-size: 40px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            font-style: italic;
            color: #27439f;
          }

          > i:nth-of-type(1) {
            width: 170px;
            height: 2px;
            background: #27439f;
            display: inline-block;
            margin: 0 7px;
          }

          > i:nth-of-type(2) {
            width: 4px;
            height: 35px;
            background: #27439f;
            display: inline-block;
            margin-right: -3px;
          }
        }

        > li:nth-of-type(1) {
          margin-top: 40px;
        }
      }

      > ul:nth-of-type(2) {
        margin-left: 26px;
        p {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          border-bottom: 1px #d9d9d9 solid;
        }
        > li:nth-of-type(1) {
          p {
            padding: 37px 0 24px 0;
          }
        }

        > li:nth-of-type(2) {
          p {
            padding: 42px 0 25px 0;
          }
        }

        > li:nth-of-type(3) {
          p {
            padding: 39px 0 17px 0;
          }
        }

        > li:nth-of-type(4) {
          p {
            padding: 27px 0 25px 0;
          }
        }

        > li:nth-of-type(5) {
          p {
            padding: 69px 0 25px 0;
          }
        }

        > li:nth-of-type(6) {
          p {
            padding: 69px 0 26px 0;
          }
        }
      }
    }
  }

  .fzlc_contentStyle {
    margin-top: 41px;
    background: #f5f6f6;
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      border-top: 1px #f6f6f6 solid;
      padding-top: 30px;
      margin-bottom: 39px;
      h3 {
        margin-bottom: 0 !important;
        font-size: 30px;
        font-weight: 400;
        margin: 0 0 88px 0;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }
    .fzlc_content {
      padding: 0 260px 0px 260px !important;
      // background: url(~@/assets/images/aboutfangzhan.png) center center
      //   no-repeat;
      .title {
        margin-bottom: 52px;
      }
    }
  }
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .content_space {
      padding: 0 7% 0px 9%;
    }
    .one {
      left: -1% !important;
    }

    .two {
      left: 29% !important;
      top: -83% !important;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import aboutImgOne from "@/assets/images/BOSAboutOne.png";
import aboutImgTwo from "@/assets/images/BOSAboutThree.png";
import aboutImgThree from "@/assets/images/BOSAboutTwo.png";
import aboutImgFour from "@/assets/images/BOSAboutFour.png";
import aboutImgFive from "@/assets/images/BOSAboutFive.png";
import aboutImgSix from "@/assets/images/BOSAboutBackground.png";
import aboutImgSeven from "@/assets/images/aboutfangzhan.png";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      tabIndex: "4",
      aboutImg:{
        picture1:aboutImgOne,
        picture2:aboutImgTwo,
        picture3:aboutImgThree,
        picture4:aboutImgFour,
        picture5:aboutImgFive,
        picture6:aboutImgSix,
        picture7:aboutImgSeven,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>